module.exports = __webpack_public_path__ + "407c0135d219d1cb1e6db21fa75f6938.svg";